var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('h2',[_vm._v(_vm._s(_vm.message))]),_c('router-link',{attrs:{"to":"/wallet/recharge"}},[_vm._v("← Back to Recharge")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }